import React, { useCallback, useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { ReactComponent as SearchIcon } from '../../../../../assets/icons/ubr_search.svg';
import { Button, Input, Select } from '../../../../../components';
import { defaultOptions_PercentualPendencias } from '../../../../../mocks/data';
import api from '../../../../../services/api';
import getValidationErrors from '../../../../../utils/getValidationErrors';
import { quantidade, periodo } from '../dataFilter';
import { ChartCard, ActionsForm, ContainerFilter } from '../styles';

interface GraficosProps {
  serie?: string;
  periodo?: number;
  quantidade?: number;
  cooperativa?: string;
  descricao?: string;
  categorias?: string;
}

interface PrincipaisCriticasSearch {
  periodo?: number;
  quantidade?: number;
  cooperativa?: string;
  descricao?: string;
  categorias?: string;
}

const GraficoPercentualPendencias: React.FC = () => {
  let selectedQuantidade = useRef<any>();
  let selectedPeriodo = useRef<any>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataPercentualPendencias, setDataPercentualPendencias] = useState<
    GraficosProps[]
  >([]);
  const [seriesPercentualPendencias, setSeriesPercentualPendencias] = useState<
    number[]
  >([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [labelsPercentualPendencias, setLabelsPercentualPendencias] = useState<
    string[]
  >([]);
  const [
    graphConfigPercentualPendencias,
    setgraphConfigPercentualPendencias,
  ] = useState<any>(defaultOptions_PercentualPendencias) as any;
  const formRef = useRef<FormHandles | null>(null);

  const fetchDataPercentualPendencias = useCallback(async () => {
    try {
      const response = await api.get(
        'pagamento/grafico/percentualPendenciaHomologacao?quantidade=5&periodo=15',
      );
      const dataPercentualPendencias = response.data;
      const labels = dataPercentualPendencias.map(
        (item: any) => item.descricao,
      );
      const series = dataPercentualPendencias.map(
        (item: any) => item.percentual,
      );
      setLabelsPercentualPendencias(labels);
      setSeriesPercentualPendencias(series);
      const Config_PercentualPendencias = {
        ...graphConfigPercentualPendencias,
        theme: {
          monochrome: {
            enabled: true,
            color: '#ab934b',
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['#ab934b'],
          curve: 'smooth',
          lineCap: 'butt',
          dashArray: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            gradientToColors: undefined,
            shadeIntensity: 0.25,
            inverseColors: true,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        labels,
        legend: {
          position: 'bottom',
        },
      };
      setgraphConfigPercentualPendencias(Config_PercentualPendencias);

      setDataPercentualPendencias(dataPercentualPendencias);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    fetchDataPercentualPendencias();
  }, [fetchDataPercentualPendencias]);

  //Filtro Principais Criticas
  const handleFilterPercentualPendencias = async (
    data: PrincipaisCriticasSearch,
  ) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        periodo: Yup.string().required('Este campo é obrigatório!'),
        quantidade: Yup.string().required('Este campo é obrigatório!'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      data.quantidade = selectedQuantidade.current;
      data.periodo = selectedPeriodo.current;
      let URL = `pagamento/grafico/percentualPendenciaHomologacao?quantidade=${data.quantidade}&periodo=${data.periodo}`;
      URL += data.cooperativa ? `&cooperativa=${data.cooperativa}` : '';
      const response = await api.get(URL);
      const dataPercentualPendencias = response.data;
      const labels = dataPercentualPendencias.map(
        (item: any) => item.descricao,
      );
      const series = dataPercentualPendencias.map(
        (item: any) => item.percentual,
      );
      setLabelsPercentualPendencias(labels);
      setSeriesPercentualPendencias(series);
      const Config_PercentualPendencias = {
        ...graphConfigPercentualPendencias,

        labels,
      };
      setgraphConfigPercentualPendencias(Config_PercentualPendencias);

      setDataPercentualPendencias(dataPercentualPendencias);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      }
    }
  };

  return (
    <>
      <ChartCard>
        <h2>% de Pendências por Cooperativa</h2>
        <Form
          className="form-container"
          ref={formRef}
          onSubmit={handleFilterPercentualPendencias}
        >
          <ContainerFilter>
            <Input
              name="cooperativa"
              label="Cooperativa"
              type="text"
              placeholder="0000"
              mask="coop"
            />
            <div className="field-select" style={{ marginLeft: '1rem' }}>
              <Select
                name={'periodo'}
                isMulti={false}
                options={periodo}
                onChange={option => (selectedPeriodo.current = option.value)}
                placeholder=" "
                label="Periodo"
                width={'100px'}
              />
            </div>
            <div className="field-select">
              <Select
                name={'quantidade'}
                isMulti={false}
                options={quantidade}
                onChange={option => (selectedQuantidade.current = option.value)}
                placeholder=""
                label="Quantidade"
                width={'100px'}
              />
            </div>

            <ActionsForm>
              <Button
                variant="solid-icon"
                type={'submit'}
                style={{ marginRight: '1rem' }}
                tooltipText={'Pesquisar'}
              >
                <SearchIcon style={{ width: '26px' }} />
              </Button>
            </ActionsForm>
          </ContainerFilter>
        </Form>

        <Chart
          options={graphConfigPercentualPendencias}
          series={seriesPercentualPendencias}
          type="pie"
          width={400}
        />
      </ChartCard>
    </>
  );
};

export default GraficoPercentualPendencias;
